// extracted by mini-css-extract-plugin
module.exports = {"root":"root_2j38K","result":"result_nU8hK"};